import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  galleryTab: boolean;
  friendsTab: boolean;
  activityTab: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }


  onMenuTab(number) {
    this.activityTab = false;
    this.friendsTab = false;
    this.galleryTab = false;
    if (number == '1') {
      this.activityTab = true;
    }
    else if (number == '2') {
      this.friendsTab = true;
    }
    else if (number == '3') {
      this.galleryTab = true;
    }
  }

}
